import classes from "./Education.module.css";
import { CardTimeline, CardTimelineItem } from "src/components/CardTimeline";

type Props = {
  alwaysOpen?: boolean;
};

const Education = ({ alwaysOpen }: Props) => {
  const educationItems: CardTimelineItem[] = [
    {
      iconClassName: classes["education-icon-unc"],
      title: "B.S. Computer Science",
      employer: "University of North Carolina at Chapel Hill",
      end: "2020",
      content: {
        description:
          "During my undergrad, I worked as a Lead Software Developer and Research Assistant at the UNC School of Education, where I led an agile development team building web-based educational simulations. This was my first experience managing a technical team and building production systems that real users depended on.",
        sections: [],
      },
      skills: [
        {
          category: "Fun fact",
          skills: [
            "I somehow convinced myself to minor in Math and ended up loving topology. Still not sure what I'll do with that knowledge, but it was a fun ride.",
          ],
        },
      ],
    },
  ];

  return (
    <div className={classes["education-wrapper"]}>
      <CardTimeline itemList={educationItems} alwaysOpen={alwaysOpen} />
    </div>
  );
};

export default Education;
